(() => {
  const animationTime = 300;

  document
    .querySelectorAll('[data-accordion-and-slides]')
    .forEach((main) => {

      // set slider
      const accordionSliderEl = main.querySelector('[data-accordion-and-slides-slider] .swiper');
      let accordionSlider = null;

      if(accordionSliderEl) {
        accordionSlider = new Swiper(accordionSliderEl, {
          allowTouchMove: false,
          effect: "fade",
        });
      }

      // set accordion functionalities
      const details = main.querySelectorAll('details');
      let canClick = true;
      
      details.forEach((detail) => {
        const summary = detail.querySelector(':scope > summary');

        if(!summary) {
          return;
        }

        summary.addEventListener('click', (ev) => {
          ev.preventDefault();
          
          if(!canClick) {
            return;
          }

          // to open
          if(!detail.open) {
            canClick = false;

            const num = detail.dataset.num;

            // close all open details
            main
              .querySelectorAll('details[open]')
              .forEach((currentlyOpenDetail) => {
                closingDetail(currentlyOpenDetail);
              });

            // open the detail
            openingDetail(
              detail, 
              () => {
                canClick = true;

                if(accordionSlider) {
                  accordionSlider.slideTo(num);
                }
              }
            );

          }
          // to close
          // else {
          //   // close the detail
          //   closingDetail(detail, () => canClick = true);
          // }

        });
      });

    });

  function closingDetail(detail, callback) {
    if(!detail) {
      return;
    }

    const summary = detail.querySelector(':scope > summary');

    if(!summary) {
      return;
    }
    
    const openHeight = detail.offsetHeight;
    const closeHeight = summary.offsetHeight;

    detail.style.height = `${openHeight}px`;

    setTimeout(() => {
      detail.style.height = `${closeHeight}px`;
      
      setTimeout(() => {
        detail.removeAttribute('style');
        detail.removeAttribute('open');
        callback && callback();
      }, animationTime);

    }, 10);
  }

  function openingDetail(detail, callback) {
    if(!detail) {
      return;
    }

    const summary = detail.querySelector(':scope > summary');

    if(!summary) {
      return;
    }

    const closeHeight = detail.offsetHeight;

    detail.style.height = `${closeHeight}px`;
    detail.setAttribute('open', '');

    const openHeight = detail.scrollHeight;

    setTimeout(() => {
      detail.style.height = `${openHeight}px`;
      
      setTimeout(() => {
        detail.removeAttribute('style');
        callback && callback();
      }, animationTime);

    }, 10);
  }

})();